<template>
  <div class="NotFound">
    <div class="wrapper">
      <h1>Page Not Found.</h1>
      <h2>Well, that's disappointing. So here's a sheep.</h2>
    
      <div class="sheep">
        <img src="/assets/ui/404-sheep-462.png" srcset="/assets/ui/404-sheep-462.png 462w, /assets/ui/404-sheep-924.png 924w" sizes="(max-width: 480px) 100vw, 462px">
      </div>
      
    </div>
    <Footer />
  </div>
</template>

<script>
import Footer from '@/components/Footer.vue'

export default {
  name: 'NotFound',
  components: {
    Footer
  },
}
</script>

<style lang="scss" scoped>
  .NotFound {
    background: #fff;
    padding: 160px 0 0 0;

    & .wrapper {
      margin: 0 auto;
      width: 1200px;
      padding: 0 0 80px 0;

      @media screen and (max-width: 1200px) {
        width: calc(100% - 80px);
      }
      @media screen and (max-width: $breakSmall) {
        width: calc(100% - 40px);
      }
    }

    & h1 {
      margin: 0 0 60px 0;
      text-align: center;
    }
    & h2 {
      text-align: center;
      margin: 0 0 60px 0;
    }

    & .sheep {
      width: 462px;
      margin: 0 auto;

      & img {
        display: block;
        width: 100%;
        height: auto;
      }

      @media screen and (max-width: 500px) {
        width: 100%;
      }
    }
    @media screen and (max-width: $breakSmall) {
      & .wrapper {
        padding: 0 0 40px 0;
      }
    }
  }
</style>